export const initialValues: { [key: string]: { [key: string]: any } } = {
  streetAddress: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  city: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  state: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  zipCode: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      maxLength: 5,
    },
  },
  propertyStatus: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },

  municipality: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  codeViolation: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  confirmProperty: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  conditionUpgradeStrategy: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
      minLength: 3,
      maxLength: 150,
    },
  },
  propertyCurrentCondition: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  propertyPhoto: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  landUtilizationPlan: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  propertyType: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  interestedPropertyType: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: false,
    },
  },
  propertyTaxes: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  waterBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  sewageBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  refuseBills: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
};

export const potentialProperty = ['Government owned', 'Privately owned', 'Delinquent'];
export const municipalities = [
  'Avalon',
  'Bellevue',
  'Blawnox',
  'Braddock',
  'Braddock Hills',
  'Carnegie',
  'Clairton',
  'Coraopolis',
  'East Pittsburgh',
  'Elizabeth Borough',
  'Forward',
  'Glassport',
  'Homestead',
  'McKees Rocks',
  'Millvale',
  'Mount Oliver',
  'North Braddock',
  'Pitcairn',
  'Rankin',
  'Sharpsburg',
  'Stowe',
  'Swissvale',
  'Tarentum',
  'Turtle Creek',
  'Verona',
  'Versailles',
  'Wall',
  'Whitaker',
  'Whitaker and Wilmerding',
];
